import { Trophy, Star, Target, Flag, Building2, Users, Heart, Handshake } from 'lucide-react';

export const currentSponsors = [
  {
    id: 1,
    name: 'Liberty Road Recreation & Parks Council',
    type: 'Official Partner',
    icon: Building2,
    color: '#4A90D9',
    description: 'Our governing body and community partner, providing facilities, league organization, and administrative support for youth athletics in Baltimore County.',
    website: 'https://libertyroadmd.myrec.com',
  },
  {
    id: 2,
    name: 'Baltimore County Dept. of Recreation & Parks',
    type: 'Community Partner',
    icon: Users,
    color: '#28A745',
    description: 'Supporting youth development through athletics, providing access to parks, fields, and recreational programs throughout Baltimore County.',
    website: null,
  },
  {
    id: 3,
    name: 'NFL FLAG Football',
    type: 'Official Program Partner',
    icon: Flag,
    color: '#FFD700',
    description: 'Proud partner of the NFL FLAG program, bringing the excitement of professional football to our youngest athletes ages 5-6 in a fun, safe, non-contact environment.',
    website: null,
  },
];

export const partnershipBenefits = [
  {
    icon: Heart,
    title: 'Community Impact',
    description: 'Your support directly impacts 200+ young athletes, helping provide equipment, uniforms, and training opportunities.',
  },
  {
    icon: Users,
    title: 'Brand Visibility',
    description: 'Get your business in front of hundreds of families at games, events, and through our digital platforms.',
  },
  {
    icon: Handshake,
    title: 'Local Connection',
    description: 'Build meaningful relationships with the Randallstown community and demonstrate your commitment to youth development.',
  },
];

export const sponsorshipTiers = [
  {
    id: 'touchdown',
    name: 'Touchdown Sponsor',
    price: '$700+',
    icon: Trophy,
    color: '#FFD700',
    featured: true,
    benefits: [
      { category: 'Digital', items: ['Welcome page banner advertisement on website', 'Feature posts on Facebook & Instagram'] },
      { category: 'On-Site', items: ['Banner posted at all Home games'] },
      { category: 'Merch', items: ['One (1) 2026 Season "Friends of the Program" T-shirt'] },
    ],
  },
  {
    id: 'field-goal',
    name: 'Field Goal Sponsor',
    price: '$400 - $699',
    icon: Target,
    color: '#C0C0C0',
    featured: false,
    benefits: [
      { category: 'Digital', items: ['Banner advertisement on website', 'Feature posts on Facebook & Instagram'] },
      { category: 'Merch', items: ['One (1) 2026 Season "Friends of the Program" T-shirt'] },
    ],
  },
  {
    id: 'extra-point',
    name: 'Extra Point Sponsor',
    price: '$200 - $399',
    icon: Star,
    color: '#CD7F32',
    featured: false,
    benefits: [
      { category: 'Digital', items: ['Listing on website', 'Shout-out posts on Facebook & Instagram'] },
      { category: 'Merch', items: ['One (1) 2026 Season "Friends of the Program" T-shirt'] },
    ],
  },
  {
    id: 'first-down',
    name: '1st Down Sponsor',
    price: '$50 - $199',
    icon: Flag,
    color: '#4A90D9',
    featured: false,
    benefits: [
      { category: 'Digital', items: ['Listing on website'] },
      { category: 'Merch', items: ['One (1) 2026 Season "Friends of the Program" T-shirt'] },
    ],
  },
];
